import React, { useEffect } from 'react';
import { LoadingPage } from '../Shared';

export const AuthResponse = () => {
  useEffect(() => {
    microsoftTeams.authentication.notifySuccess();
    setTimeout(() => {
      if (window.opener && window.opener !== window) {
        window.close();
      }
    }, 1000);
  }, []);

  return <LoadingPage subtext='Almost done...' fullscreen />;
};
